import { useSelector } from "react-redux";
import { IRepoV2ReduxState } from "repoV2/features/Common/modules/Reducer/Reducer.interface";
import { useGetAddressDetailsHelpers } from "repoV2/features/CheckoutPages/utils/useGetAddressDetailsHelpers";
import {
    LISTING_STATUSES,
    LISTING_TYPES,
} from "repoV2/features/Listing/Listing.constants";
import { useCheckoutBasicDetailsContext } from "../../../CheckoutBasicDetailsContextProvider";
import { useHideSessionDetailsFormGroup } from "../FormGroups/modules/SessionDetailsFormGroup/SessionDetailsFormGroup.utils";

const usePaymentDetailsForm = () => {
    const {
        listingStatus,
        listingUuid,
        listingType,
        hideCouponCodeField,
        isListingExpressInterest,
        hideListingPrice,
    } = useCheckoutBasicDetailsContext();

    const { showDeliveryDetailsFormGroup } = useGetAddressDetailsHelpers();

    const showPartPaymentDetails = useSelector(
        (state: IRepoV2ReduxState) =>
            state.checkoutPages.listingDetails[listingUuid]?.partPaymentDetails
                ?.data?.shouldAllowPartPayments
    );

    const { hideSessionDetailsFormGroup } = useHideSessionDetailsFormGroup({
        listingType,
        listingStatus,
    });

    /**
     * We need to hide the order-bumps for group in the following cases -
     - isDynamicLink: if the checkout page is a dynamic payment link, then we now show order bumps on
     * it, as the pricing is different on dynamic payment pages also, we have a functionality
     * to have multiple payment pages withh different order bumps on each
     - isListingExpressInterest: If the listing is expired or in waitlist, then we do not show booking form, 
     * so no point there to show order-bumps to the user
     - hideListingPrice: it is a check on admin panel currently, which hides the booking form and show express interest to the user
     - listingStatus !== LISTING_STATUSES.LIVE: an explicit check to make it sure that the status of listing is not live, as if 
       its not then we do not show order bumps to user
     */
    const hideOrderBumpsFormGroup =
        isListingExpressInterest ||
        hideListingPrice ||
        listingStatus !== LISTING_STATUSES.LIVE;

    const hideMerchandiseDetailsFormGroup =
        listingType !== LISTING_TYPES.MERCHANDISE;

    return {
        hideCouponCodeField,
        hideSessionDetailsFormGroup,
        hidePartPaymentsFormGroup: !showPartPaymentDetails,
        hideOrderBumpsFormGroup,
        hideDeliveryDetailsFormGroup: !showDeliveryDetailsFormGroup,
        hideMerchandiseDetailsFormGroup,
    };
};

export default usePaymentDetailsForm;
